import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Grid } from '@mui/material';
import { Box } from '@mui/material';

import { useProcedurePqrForm } from '../hook';
import { ProcedureParamsData } from './data';
import { ProcedureHistorical } from '../historical';

import FormView from '../../../../components/views/formView';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { isTrainerOrQuality } from '../../../../../shared/types/profiles';
import {
    PROCEDURE_EDIT,
    PROCEDURE_NEW,
    PROCEDURE,
    PROCEDURE_DETAIL,
} from '../../../../../routes/paths';

export const ProcedureForm = () => {
    const [showHistorical, setShowHistorical] = useState(false);

    const {
        procedure,
        loading,
        handleSubmit,
        handleCleanAndBack,
        setformikProcedureData,
        procedureHistorical,
    } = useProcedurePqrForm(showHistorical);

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    const showActionButtons = procedure && procedure?.id ? true : false;

    return (
        <>
            <FormView
                title={
                    procedure && procedure.id
                        ? 'Editar trámite PQR'
                        : 'Crear trámite PQR'
                }
                additionalButtons={
                    <ActionButtonGroup
                        id={procedure?.id || ''}
                        buttonCreate={{
                            show:
                                showActionButtons && !isTrainerOrQuality(type),
                            route: PROCEDURE_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: PROCEDURE,
                        }}
                        buttonUpdate={{
                            show:
                                !showActionButtons && !isTrainerOrQuality(type),
                            route: PROCEDURE_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: PROCEDURE_DETAIL,
                        }}
                        buttonLog={{
                            show: showActionButtons,
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            />
            {showHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <ProcedureHistorical
                        historical={procedureHistorical ?? []}
                        showHistorical={true}
                    />
                </Box>
            )}
            <ProcedureParamsData
                data={procedure}
                onChangeFormik={(formik) => setformikProcedureData(formik)}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Volver"
                    variant="outlined"
                    onClick={handleCleanAndBack}
                />
            </Grid>
        </>
    );
};
